<template>
  <v-container fluid class="grid-wrapper">
    <h1>
      Bienvenue dans votre espace de création, gestion et consultation des associations
      d'Alsace-Moselle
    </h1>
    <div class="card-grid">
        <a-action-possible-registre-card
          color="secondary"
          icon="mdi-book-outline"
          titre="CONSULTER"
          @click="versRegistre"
          class="card-full-width"
          data-testid="consulter-association"
        >
          <p>Vous recherchez des informations sur une association ?</p>
          <p>
            Consultez le registre des associations d'Alsace-Moselle ainsi que leurs
            annexes.
          </p>
          <template #actions> CONSULTER LE REGISTRE </template>
        </a-action-possible-registre-card>
        <a-action-possible-registre-card
          color="information"
          icon="mdi-plus-outline"
          titre="CRÉER"
          @click="versCreation"
          class="card-full-width"
          data-testid="creer-association"
        >
          <p>Vous souhaitez créer une association ?</p>
          <p>
            Déposez une requête qui sera traitée par la juridiction compétente dans le
            ressort du siège de l'association.
          </p>
          <template #actions> CRÉER MON ASSOCIATION</template>
        </a-action-possible-registre-card>
        <a-action-possible-registre-card
          color="lightprimary"
          icon="mdi-reply-outline"
          titre="SUIVRE"
          @click="versRequetes"
          class="card-full-width"
          data-testid="suivre-activite"
        >
        <div class="card-content">
          <p> Vous souhaitez suivre l'activité liée à vos associations ?</p>
          <ul>
            <li>Répondez aux demandes du tribunal</li>
            <li>Consultez les derniers documents</li>
            <li>Visualisez les requêtes de vos associations</li>
          </ul>
        </div>
          <v-hover v-slot="{ hover }">
            <v-alert
              v-if="avecActionsRequetes"
              type="warning"
              class="mt-3"
              :icon="false"
              :outlined="hover"
            >
              Une action est requise de votre part.
            </v-alert>
          </v-hover>
          <v-hover v-slot="{ hover }">
          <v-alert
            v-if="avecRequetesRecentes"
            color="primary"
            class="mt-3"
            :icon="false"
            :outlined="hover"
            :dark="!hover"
          >
            Nouveaux documents disponibles.
          </v-alert>
          </v-hover>
          <template #actions> ACCÉDER AU SUIVI</template>
        </a-action-possible-registre-card>
        <a-action-possible-registre-card
          color="primary"
          icon="mdi-folder-outline"
          titre="GÉRER"
          @click="versMesAssociations"
          class="card-full-width"
          data-testid="gerer-association"
        >
          <p>Vous souhaitez gérer les associations auxquelles vous êtes rattaché ?</p>
          <ul>
            <li>Effectuez vos formalités (modifications ou dissolution / radiation)</li>
            <li>Administrez et invitez des utilisateurs</li>
            <li>Visualisez l'ensemble des données de vos associations</li>
          </ul>
          <v-hover v-slot="{ hover }">
            <v-alert
              v-if="avecActionsAssociations"
              type="warning"
              class="mt-3"
              :icon="false"
              :outlined="hover"
            >
              Une action est requise de votre part.
            </v-alert>
          </v-hover>
          <template #actions> GÉRER MES ASSOCIATIONS </template>
        </a-action-possible-registre-card>
        <a-action-possible-registre-card
          color="darkprimary"
          icon="mdi-link-variant"
          titre="SE RATTACHER"
          @click="versRegistre"
          class="card-full-width"
          data-testid="se-rattacher-association"
        >
          <p>Vous souhaitez vous rattacher à vos associations ?</p>
          <p>
            Recherchez votre association dans le
            <strong class="darkprimary--text font-weight-bold text-decoration-underline"
              >registre</strong
            >
            et effectuez une demande de rattachement à celle-ci.
          </p>
          <p class="darkprimary--text font-weight-bold">
            Vous devez d'abord vous rattacher à une association afin de pouvoir la gérer.
          </p>
          <template #actions> SE RATTACHER À MON ASSOCIATION</template>
        </a-action-possible-registre-card>
      </div>
  </v-container>
</template>

<script>
import { principalService } from "@/services";

export default {
  data() {
    return {
      associations: [],
      requetes: [],
      loading: false,
    };
  },

  mounted() {
    this.load();
  },

  computed: {
    avecActionsAssociations() {
      return this.associations.some(a => a.invitation);
    },
    avecActionsRequetes() {
      return this.requetes.some(r => !!r.demandesPieces?.length);
    },
    avecRequetesRecentes() {
      return this.requetes.some(r => r.requete.nouveauxDocuments);
    },
  },

  methods: {
    versCreation() {
      this.$router.push({ path: "/creation" });
    },
    versMesAssociations() {
      this.$router.push({ path: "/mes-associations" });
    },
    versRegistre() {
      this.$router.push({ path: "/association" });
    },
    versRequetes() {
      this.$router.push({ path: "/requete" });
    },
    load() {
      this.loading = true;
      Promise.all([
        principalService.dashboardAssociations(),
        principalService.dashboardRequetes(),
      ])
        .then(([{ associations }, { requetes }]) => {
          this.associations = associations;
          this.requetes = requetes;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.card-full-width {
  width: 100%;
}

.grid-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 100px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  justify-items: center;
  align-items: stretch;
  width: 100%;
}
</style>
